module.exports = __webpack_public_path__ + "static/media/employees-active.e7133f8d.svg";